import { ROUTES } from "../../../components/shared/constant";
import { NAV_IDS, type NavId } from "./sidebarConfig";
import { WORKFORCE_NAV_IDS, type WorkforceNavId } from "../../workforce/nav/workforceNavConfig";
import { EMPLOYEE_NAV_IDS, type EmployeeNavId } from "../../employee/nav/employeeNavConfig";
import { adminViewPath } from "../../../routes/employeePaths";

export function getNavRoute(navId: NavId): string {
  return NAV_TO_ROUTE_BASE[navId] ?? "/";
}

const NAV_TO_ROUTE_BASE: Partial<Record<NavId, string>> = {
  [NAV_IDS.FOR_YOU]: ROUTES.HOME,
  [NAV_IDS.SETTINGS]: ROUTES.EMAIL_SETTINGS,
  // [NAV_IDS.GENERAL]: ROUTES.GENERAL_SETTINGS, // Removed — page no longer exists
  [NAV_IDS.ROLES]: ROUTES.USERS,
  [NAV_IDS.LOGS]: ROUTES.LOGS,
  [NAV_IDS.INSTANCES]: ROUTES.VIEWINSTANCES,
  [NAV_IDS.TENANTS]: ROUTES.TENANTSETIINGS,
  [NAV_IDS.EMAIL_SETTINGS]: ROUTES.EMAIL_SETTINGS,
  [NAV_IDS.FIELDS]: ROUTES.FIELDS,
  [NAV_IDS.APP_PREFERENCES]: ROUTES.APP_PREFERENCES,
  [NAV_IDS.SENIOR_LIVING]: ROUTES.SENIOR_LIVING,
  [NAV_IDS.SENIOR_LIVING_RESIDENTS]: ROUTES.SENIOR_LIVING_RESIDENTS,
  [NAV_IDS.SENIOR_LIVING_COMMUNITY]: ROUTES.SENIOR_LIVING_COMMUNITY_DASHBOARD,
  [NAV_IDS.HEALTH_PLAN]: ROUTES.HEALTH_PLAN,
  [NAV_IDS.HEALTH_PLAN_PARTICIPANTS]: ROUTES.HEALTH_PLAN_PARTICIPANTS,
  [NAV_IDS.HEALTH_PLAN_REPRESENTATIVES]: ROUTES.HEALTH_PLAN_REPRESENTATIVES,
  [NAV_IDS.HEALTH_PLAN_ENROLLMENT]: ROUTES.HEALTH_PLAN_ENROLLMENT,
  [NAV_IDS.NAVIGATOR]: ROUTES.NAVIGATOR,
  [NAV_IDS.NAVIGATOR_AGREEMENTS]: ROUTES.NAVIGATOR_AGREEMENTS,
  [NAV_IDS.NAVIGATOR_ALERTS]: ROUTES.NAVIGATOR_ALERTS,
  [NAV_IDS.WEB_FORMS]: ROUTES.WEB_FORMS,
  [NAV_IDS.TICKETS]: ROUTES.INBOX,
  [NAV_IDS.PORTALS]: ROUTES.PORTALS,
  [NAV_IDS.PORTALS_DASHBOARD]: ROUTES.PORTALS_DASHBOARD,
  [NAV_IDS.CUSTOMER_PORTALS]: ROUTES.CUSTOMER_PORTALS,
  [NAV_IDS.CUSTOMER_PORTAL_SETTINGS]: ROUTES.CUSTOMER_PORTAL_SETTINGS,
  [NAV_IDS.USER_MANUAL]: ROUTES.USER_MANUAL,
  [NAV_IDS.PEOPLE_CONTACTS]: ROUTES.PEOPLE_CONTACTS,
  [NAV_IDS.PEOPLE_ORGANIZATIONS]: ROUTES.PEOPLE_ORGANIZATIONS,
  [NAV_IDS.AI_PLAYGROUND]: ROUTES.AI_PLAYGROUND,
  [NAV_IDS.SKYAGENT]: ROUTES.SKYAGENT,
  [NAV_IDS.SKYAGENT_CONFIGURATION]: ROUTES.SKYAGENT_CONFIGURATION,
  [NAV_IDS.SKYBRAIN_SYSTEM_PROMPT]: ROUTES.SKYBRAIN_SYSTEM_PROMPT,
  [NAV_IDS.SKYBRAIN_MEMORY]: ROUTES.SKYBRAIN_MEMORY,
  [NAV_IDS.SKYBRAIN_SKILLS]: ROUTES.SKYBRAIN_SKILLS,
  [NAV_IDS.SKYBRAIN_INTEGRATIONS]: ROUTES.SKYBRAIN_INTEGRATIONS,
  [NAV_IDS.SKYBRAIN_INDEX]: ROUTES.SKYBRAIN_INDEX,
  [NAV_IDS.SKYBRAIN_SETTINGS]: ROUTES.SKYBRAIN_SETTINGS,
};

const ROUTE_PATTERNS: Partial<Record<NavId, string[]>> = {
  [NAV_IDS.FOR_YOU]: [ROUTES.HOME, ROUTES.PORTALS_YOUR_WORK],
  [NAV_IDS.SETTINGS]: [],
  // [NAV_IDS.GENERAL]: [ROUTES.GENERAL_SETTINGS], // Removed
  [NAV_IDS.ROLES]: [ROUTES.USERS, ROUTES.ROLES],
  [NAV_IDS.LOGS]: [ROUTES.LOGS],
  [NAV_IDS.INSTANCES]: [
    ROUTES.VIEWINSTANCES,
    ROUTES.VIEWINSTANCEDETAILS,
    ROUTES.VIEWINSTANCEHISTORY,
    ROUTES.VIEWINSTANCEBACKUP,
  ],
  [NAV_IDS.TENANTS]: [ROUTES.TENANTSETIINGS, ROUTES.CREATETENANT],
  [NAV_IDS.EMAIL_SETTINGS]: [ROUTES.EMAIL_SETTINGS],
  [NAV_IDS.FIELDS]: [ROUTES.FIELDS],
  [NAV_IDS.APP_PREFERENCES]: [ROUTES.APP_PREFERENCES],
  [NAV_IDS.SENIOR_LIVING]: [ROUTES.SENIOR_LIVING],
  [NAV_IDS.SENIOR_LIVING_RESIDENTS]: [
    ROUTES.SENIOR_LIVING_RESIDENTS,
    ROUTES.SENIOR_LIVING_RESIDENT_DETAIL,
  ],
  [NAV_IDS.SENIOR_LIVING_COMMUNITY]: [ROUTES.SENIOR_LIVING_COMMUNITY_DASHBOARD],
  [NAV_IDS.HEALTH_PLAN]: [ROUTES.HEALTH_PLAN],
  [NAV_IDS.HEALTH_PLAN_PARTICIPANTS]: [
    ROUTES.HEALTH_PLAN_PARTICIPANTS,
    ROUTES.HEALTH_PLAN_PARTICIPANT_DETAIL,
  ],
  [NAV_IDS.HEALTH_PLAN_REPRESENTATIVES]: [ROUTES.HEALTH_PLAN_REPRESENTATIVES],
  [NAV_IDS.HEALTH_PLAN_ENROLLMENT]: [ROUTES.HEALTH_PLAN_ENROLLMENT],
  [NAV_IDS.NAVIGATOR]: [ROUTES.NAVIGATOR],
  [NAV_IDS.NAVIGATOR_AGREEMENTS]: [ROUTES.NAVIGATOR_AGREEMENTS, ROUTES.NAVIGATOR_AGREEMENT_DETAIL],
  [NAV_IDS.NAVIGATOR_ALERTS]: [ROUTES.NAVIGATOR_ALERTS],
  [NAV_IDS.WEB_FORMS]: [ROUTES.WEB_FORMS, ROUTES.WEB_FORM_EDIT],
  [NAV_IDS.TICKETS]: [ROUTES.INBOX, ROUTES.TICKETS],
  [NAV_IDS.PORTALS]: [
    ROUTES.PORTALS,
    ROUTES.PORTALS_CREATE,
    ROUTES.PORTAL_BOARD,
    ROUTES.PORTAL_LIST,

    ROUTES.PORTAL_CALENDAR,

    ROUTES.PORTAL_ITEM_DETAIL,
    ROUTES.PORTAL_ITEM_NEW,
    ROUTES.PORTAL_SETTINGS,
    ROUTES.PORTAL_SETTINGS_DETAILS,
    ROUTES.PORTAL_SETTINGS_ACCESS,
    ROUTES.PORTAL_SETTINGS_WORKFLOW,
    ROUTES.PORTAL_SETTINGS_SERVICE_DESK,
    ROUTES.PORTAL_SETTINGS_AGENT_GROUPS,
    ROUTES.PORTAL_SETTINGS_QUEUES,
    ROUTES.PORTAL_SETTINGS_EMAIL,
    ROUTES.PORTAL_SETTINGS_ASSIGNMENT_MATRIX,
    ROUTES.PORTAL_SETTINGS_CUSTOM_FIELDS,
    ROUTES.PORTAL_SETTINGS_SLA,
    ROUTES.PORTAL_SETTINGS_BUSINESS_HOURS,
    ROUTES.PORTAL_SETTINGS_AUTOMATIONS,
    ROUTES.PORTAL_SETTINGS_AUTOMATION_EDIT,
    ROUTES.PORTAL_REPORTS,
    ROUTES.PORTAL_REPORT_CREATED_VS_RESOLVED,
    ROUTES.PORTAL_REPORT_SLA_COMPLIANCE,
    ROUTES.PORTAL_REPORT_AGENT_PERFORMANCE,
    ROUTES.PORTAL_REPORT_REQUEST_TYPES,
    ROUTES.PORTAL_REPORT_RESOLUTION_TIME,
    ROUTES.PORTAL_QUEUES,
    ROUTES.PORTAL_QUEUE_VIEW,
    ROUTES.PORTAL_SETTINGS_AI_AGENT,
  ],
  [NAV_IDS.PORTALS_DASHBOARD]: [ROUTES.PORTALS_DASHBOARD],
  [NAV_IDS.CUSTOMER_PORTALS]: [
    ROUTES.CUSTOMER_PORTALS,
    ROUTES.CUSTOMER_PORTAL_DETAIL,
    ROUTES.CUSTOMER_MY_REQUESTS,
    ROUTES.CUSTOMER_REQUEST_DETAIL,
  ],
  [NAV_IDS.CUSTOMER_PORTAL_SETTINGS]: [ROUTES.CUSTOMER_PORTAL_SETTINGS],
  [NAV_IDS.USER_MANUAL]: [ROUTES.USER_MANUAL],
  [NAV_IDS.PEOPLE_CONTACTS]: [ROUTES.PEOPLE_CONTACTS, ROUTES.PEOPLE_CONTACT_DETAIL],
  [NAV_IDS.PEOPLE_ORGANIZATIONS]: [ROUTES.PEOPLE_ORGANIZATIONS, ROUTES.PEOPLE_ORGANIZATION_DETAIL],
  [NAV_IDS.AI_PLAYGROUND]: [ROUTES.AI_PLAYGROUND],
  [NAV_IDS.SKYAGENT]: [ROUTES.SKYAGENT],
  [NAV_IDS.SKYAGENT_CONFIGURATION]: [ROUTES.SKYAGENT_CONFIGURATION],
  // Sub-pages listed before Overview: /skybrain/<page> also matches /skybrain
  // as a prefix, so the more specific route has to win or Overview highlights.
  [NAV_IDS.SKYBRAIN_INDEX]: [ROUTES.SKYBRAIN_INDEX],
  [NAV_IDS.SKYBRAIN_SETTINGS]: [ROUTES.SKYBRAIN_SETTINGS],
  [NAV_IDS.SKYBRAIN_SYSTEM_PROMPT]: [ROUTES.SKYBRAIN_SYSTEM_PROMPT],
  [NAV_IDS.SKYBRAIN_MEMORY]: [ROUTES.SKYBRAIN_MEMORY],
  [NAV_IDS.SKYBRAIN_SKILLS]: [ROUTES.SKYBRAIN_SKILLS],
  [NAV_IDS.SKYBRAIN_INTEGRATIONS]: [ROUTES.SKYBRAIN_INTEGRATIONS],
};

export function getSelectedNavItem(
  pathname: string,
  queryString: string = "",
): {
  selectedId: string | undefined;
  selectedCategoryId: string | undefined;
} {
  let bestMatch: { navId: string; patternLength: number } | null = null;

  for (const [navId, patterns] of Object.entries(ROUTE_PATTERNS)) {
    for (const pattern of patterns) {
      const routeWithQuery = pattern + queryString;

      if (pathname === pattern || pathname === routeWithQuery) {
        if (!bestMatch || pattern.length > bestMatch.patternLength) {
          bestMatch = { navId, patternLength: pattern.length };
        }
      } else if (pathname.startsWith(pattern + "/") || pathname.startsWith(pattern + "?")) {
        if (!bestMatch || pattern.length > bestMatch.patternLength) {
          bestMatch = { navId, patternLength: pattern.length };
        }
      }
    }
  }

  if (bestMatch) {
    // For portal sub-routes, derive the specific portal child ID for selection
    if (bestMatch.navId === NAV_IDS.PORTALS) {
      const portalKeyMatch = pathname.match(/^\/portals\/([^/]+)\//);
      if (portalKeyMatch) {
        return {
          selectedId: `portal-${portalKeyMatch[1]}`,
          selectedCategoryId: NAV_IDS.PORTALS,
        };
      }
    }

    return {
      selectedId: bestMatch.navId,
      selectedCategoryId: getParentCategoryId(bestMatch.navId as NavId),
    };
  }

  return {
    selectedId: NAV_IDS.FOR_YOU,
    selectedCategoryId: undefined,
  };
}

function getParentCategoryId(navId: NavId): string | undefined {
  const settingsSubmenu: NavId[] = [
    NAV_IDS.EMAIL_SETTINGS,
    NAV_IDS.FIELDS,
    NAV_IDS.APP_PREFERENCES,
    NAV_IDS.ROLES,
    NAV_IDS.LOGS,
    NAV_IDS.INSTANCES,
    NAV_IDS.TENANTS,
    NAV_IDS.CUSTOMER_PORTAL_SETTINGS,
    NAV_IDS.USER_MANUAL,
  ];

  if (settingsSubmenu.includes(navId)) {
    return NAV_IDS.SETTINGS;
  }

  return undefined;
}

// ============================================================
// Workforce Lifecycle Management (WLM) nav mapping
// ============================================================

const WORKFORCE_NAV_TO_ROUTE: Record<WorkforceNavId, string> = {
  [WORKFORCE_NAV_IDS.DASHBOARDS]: ROUTES.WORKFORCE_DASHBOARDS,
  [WORKFORCE_NAV_IDS.PEOPLE]: ROUTES.WORKFORCE_PEOPLE,
  [WORKFORCE_NAV_IDS.ORG]: ROUTES.WORKFORCE_ORG,
  [WORKFORCE_NAV_IDS.LIFECYCLE]: ROUTES.WORKFORCE_LIFECYCLE,
  [WORKFORCE_NAV_IDS.ACCESS]: ROUTES.WORKFORCE_ACCESS,
  [WORKFORCE_NAV_IDS.APPLICATIONS]: ROUTES.WORKFORCE_APPLICATIONS,
  [WORKFORCE_NAV_IDS.ASSETS]: ROUTES.WORKFORCE_ASSETS,
  [WORKFORCE_NAV_IDS.LICENSES]: ROUTES.WORKFORCE_LICENSES,
  [WORKFORCE_NAV_IDS.REPORTS]: ROUTES.WORKFORCE_REPORTS,
  [WORKFORCE_NAV_IDS.SETTINGS]: ROUTES.WORKFORCE_SETTINGS,
  [WORKFORCE_NAV_IDS.USERS]: ROUTES.USERS,
  // The SHARED routes, not workforce copies — one agent, one history, one set
  // of settings. `isModuleNeutralRoute` below decides which of these need
  // `from=workforce` so the shell does not flip product when they open.
  [WORKFORCE_NAV_IDS.SKYAGENT]: ROUTES.SKYAGENT,
  [WORKFORCE_NAV_IDS.SKYAGENT_CONFIGURATION]: ROUTES.SKYAGENT_CONFIGURATION,
  [WORKFORCE_NAV_IDS.SKYBRAIN_SYSTEM_PROMPT]: ROUTES.SKYBRAIN_SYSTEM_PROMPT,
  [WORKFORCE_NAV_IDS.SKYBRAIN_MEMORY]: ROUTES.SKYBRAIN_MEMORY,
  [WORKFORCE_NAV_IDS.SKYBRAIN_SKILLS]: ROUTES.SKYBRAIN_SKILLS,
  [WORKFORCE_NAV_IDS.SKYBRAIN_INTEGRATIONS]: ROUTES.SKYBRAIN_INTEGRATIONS,
  [WORKFORCE_NAV_IDS.SKYBRAIN_INDEX]: ROUTES.SKYBRAIN_INDEX,
  [WORKFORCE_NAV_IDS.SKYBRAIN_SETTINGS]: ROUTES.SKYBRAIN_SETTINGS,
};

/**
 * Workforce nav entries whose route is shared with Service Desk.
 *
 * Opening one must keep the Workforce shell, which `isWorkforceContext` decides
 * from `?from=workforce` for a path outside /workforce. Derived from the route
 * rather than listed by nav id, so a new shared entry cannot be added without
 * picking up the parameter.
 */
export function isModuleNeutralWorkforceRoute(navId: WorkforceNavId): boolean {
  const route = WORKFORCE_NAV_TO_ROUTE[navId];
  return (
    route?.startsWith(ROUTES.SKYAGENT) === true ||
    route?.startsWith(ROUTES.SKYBRAIN) === true ||
    route === ROUTES.USERS
  );
}

// ── skyEmployee ──

const EMPLOYEE_NAV_TO_ROUTE: Record<EmployeeNavId, string> = {
  [EMPLOYEE_NAV_IDS.HOME]: ROUTES.EMPLOYEE_HOME,
  [EMPLOYEE_NAV_IDS.ADMIN_USERS]: ROUTES.USERS,
  [EMPLOYEE_NAV_IDS.ADMIN_ORGANISATION]: ROUTES.EMPLOYEE_ADMIN_USERS,
  [EMPLOYEE_NAV_IDS.ADMIN_SETTINGS]: ROUTES.EMPLOYEE_ADMIN_SETTINGS,
  [EMPLOYEE_NAV_IDS.ADMIN_MESSAGING]: ROUTES.EMPLOYEE_ADMIN_MESSAGING,
  [EMPLOYEE_NAV_IDS.ADMIN_RECOGNITION]: ROUTES.EMPLOYEE_ADMIN_RECOGNITION,
  [EMPLOYEE_NAV_IDS.ADMIN_GIFTCARDS]: ROUTES.EMPLOYEE_ADMIN_GIFTCARDS,
  [EMPLOYEE_NAV_IDS.ADMIN_LIBRARY]: ROUTES.EMPLOYEE_ADMIN_LIBRARY,
  [EMPLOYEE_NAV_IDS.ADMIN_BENEFITS]: ROUTES.EMPLOYEE_ADMIN_BENEFITS,
  [EMPLOYEE_NAV_IDS.MANAGE_SCOPE]: ROUTES.EMPLOYEE_MANAGE_SCOPE,
  [EMPLOYEE_NAV_IDS.MANAGE_CONTENT]: ROUTES.EMPLOYEE_MANAGE_CONTENT,
  [EMPLOYEE_NAV_IDS.MANAGE_REPORTS]: ROUTES.EMPLOYEE_MANAGE_REPORTS,
  [EMPLOYEE_NAV_IDS.MANAGE_ACKS]: ROUTES.EMPLOYEE_MANAGE_ACKS,
  [EMPLOYEE_NAV_IDS.MANAGE_BROADCASTS]: ROUTES.EMPLOYEE_MANAGE_BROADCASTS,
  [EMPLOYEE_NAV_IDS.REQUESTS]: adminViewPath(ROUTES.EMPLOYEE_MY_REQUESTS),
  [EMPLOYEE_NAV_IDS.MESSAGES]: adminViewPath(ROUTES.EMPLOYEE_MY_MESSAGES),
  [EMPLOYEE_NAV_IDS.DIRECTORY]: adminViewPath(ROUTES.EMPLOYEE_MY_DIRECTORY),
  [EMPLOYEE_NAV_IDS.REWARDS]: adminViewPath(ROUTES.EMPLOYEE_MY_REWARDS),
  [EMPLOYEE_NAV_IDS.LEADERBOARD]: adminViewPath(ROUTES.EMPLOYEE_MY_LEADERBOARD),
  [EMPLOYEE_NAV_IDS.SURVEYS]: adminViewPath(ROUTES.EMPLOYEE_MY_SURVEYS),
  [EMPLOYEE_NAV_IDS.RESOURCES]: adminViewPath(ROUTES.EMPLOYEE_MY_RESOURCES),
  [EMPLOYEE_NAV_IDS.BENEFITS]: adminViewPath(ROUTES.EMPLOYEE_MY_BENEFITS),
  [EMPLOYEE_NAV_IDS.MY_HOME]: ROUTES.EMPLOYEE_MY_HOME,
  [EMPLOYEE_NAV_IDS.MY_REQUESTS]: ROUTES.EMPLOYEE_MY_REQUESTS,
  [EMPLOYEE_NAV_IDS.MY_MESSAGES]: ROUTES.EMPLOYEE_MY_MESSAGES,
  [EMPLOYEE_NAV_IDS.MY_DIRECTORY]: ROUTES.EMPLOYEE_MY_DIRECTORY,
  [EMPLOYEE_NAV_IDS.MY_REWARDS]: ROUTES.EMPLOYEE_MY_REWARDS,
  [EMPLOYEE_NAV_IDS.MY_LEADERBOARD]: ROUTES.EMPLOYEE_MY_LEADERBOARD,
  [EMPLOYEE_NAV_IDS.MY_SURVEYS]: ROUTES.EMPLOYEE_MY_SURVEYS,
  [EMPLOYEE_NAV_IDS.MY_RESOURCES]: ROUTES.EMPLOYEE_MY_RESOURCES,
  [EMPLOYEE_NAV_IDS.MY_BENEFITS]: ROUTES.EMPLOYEE_MY_BENEFITS,
};

/** skyEmployee entries whose route is shared (Users & access): they carry `from=employee`. */
export function isModuleNeutralEmployeeRoute(navId: EmployeeNavId): boolean {
  return EMPLOYEE_NAV_TO_ROUTE[navId] === ROUTES.USERS;
}

export function getEmployeeNavRoute(navId: EmployeeNavId): string {
  return EMPLOYEE_NAV_TO_ROUTE[navId] ?? ROUTES.EMPLOYEE_HOME;
}

/** Longest-prefix match of pathname against skyEmployee routes; Home by default. */
export function getSelectedEmployeeNavItem(pathname: string): string {
  let bestMatch: { navId: string; patternLength: number } | null = null;
  for (const [navId, pattern] of Object.entries(EMPLOYEE_NAV_TO_ROUTE)) {
    const isMatch =
      pathname === pattern ||
      pathname.startsWith(pattern + "/") ||
      pathname.startsWith(pattern + "?");
    if (isMatch && (!bestMatch || pattern.length > bestMatch.patternLength)) {
      bestMatch = { navId, patternLength: pattern.length };
    }
  }
  if (bestMatch) return bestMatch.navId;
  // Raising a new request is part of My requests, in either view.
  const isUnder = (p: string) =>
    pathname === p || pathname.startsWith(p + "/") || pathname.startsWith(p + "?");
  if (isUnder(ROUTES.EMPLOYEE_MY_NEW_REQUEST)) return EMPLOYEE_NAV_IDS.MY_REQUESTS;
  if (isUnder(adminViewPath(ROUTES.EMPLOYEE_MY_NEW_REQUEST))) return EMPLOYEE_NAV_IDS.REQUESTS;
  // The profile pages have no menu item; highlight nothing rather than Home.
  if (isEmployeeProfilePath(pathname)) return "";
  return EMPLOYEE_NAV_IDS.HOME;
}

function isEmployeeProfilePath(pathname: string): boolean {
  return [
    ROUTES.EMPLOYEE_PROFILE,
    ROUTES.EMPLOYEE_MY_PROFILE,
    ROUTES.EMPLOYEE_MY_NOTIFICATION_SETTINGS,
    ROUTES.EMPLOYEE_NOTIFICATION_SETTINGS,
  ].some((p) => pathname === p || pathname.startsWith(p + "/") || pathname.startsWith(p + "?"));
}

export function getWorkforceNavRoute(navId: WorkforceNavId): string {
  return WORKFORCE_NAV_TO_ROUTE[navId] ?? ROUTES.WORKFORCE_PEOPLE;
}

/** Longest-prefix match of pathname against WLM routes; People by default. */
export function getSelectedWorkforceNavItem(pathname: string): string {
  // Person profile (/workforce/people/:agentId) highlights People.
  if (
    pathname === ROUTES.WORKFORCE_PEOPLE ||
    pathname.startsWith(ROUTES.WORKFORCE_PEOPLE + "/") ||
    pathname.startsWith(ROUTES.WORKFORCE_PEOPLE + "?")
  ) {
    return WORKFORCE_NAV_IDS.PEOPLE;
  }

  // Application-access detail (/workforce/applications/:slug) highlights
  // Applications. The generic loop below also maps the base
  // /workforce/applications to Applications via WORKFORCE_NAV_TO_ROUTE; this
  // explicit check keeps the slug detail highlighting correct regardless.
  if (pathname.startsWith(ROUTES.WORKFORCE_APPLICATIONS)) {
    return WORKFORCE_NAV_IDS.APPLICATIONS;
  }

  // First-run setup (/workforce/setup) belongs to the Settings area.
  if (
    pathname === ROUTES.WORKFORCE_SETUP ||
    pathname.startsWith(ROUTES.WORKFORCE_SETUP + "/") ||
    pathname.startsWith(ROUTES.WORKFORCE_SETUP + "?")
  ) {
    return WORKFORCE_NAV_IDS.SETTINGS;
  }

  // The shared skyAgent/skyBrain routes, matched before the generic loop below.
  // They sit outside /workforce, so without this the loop falls through to its
  // People default and the workforce sidebar highlights the wrong row while the
  // agent is open.
  if (pathname === ROUTES.SKYAGENT || pathname.startsWith(ROUTES.SKYAGENT + "/")) {
    return pathname.startsWith(ROUTES.SKYAGENT_CONFIGURATION)
      ? WORKFORCE_NAV_IDS.SKYAGENT_CONFIGURATION
      : WORKFORCE_NAV_IDS.SKYAGENT;
  }
  if (pathname === ROUTES.SKYBRAIN || pathname.startsWith(ROUTES.SKYBRAIN + "/")) {
    const brain: [string, string][] = [
      [ROUTES.SKYBRAIN_SYSTEM_PROMPT, WORKFORCE_NAV_IDS.SKYBRAIN_SYSTEM_PROMPT],
      [ROUTES.SKYBRAIN_MEMORY, WORKFORCE_NAV_IDS.SKYBRAIN_MEMORY],
      [ROUTES.SKYBRAIN_SKILLS, WORKFORCE_NAV_IDS.SKYBRAIN_SKILLS],
      [ROUTES.SKYBRAIN_INTEGRATIONS, WORKFORCE_NAV_IDS.SKYBRAIN_INTEGRATIONS],
      [ROUTES.SKYBRAIN_INDEX, WORKFORCE_NAV_IDS.SKYBRAIN_INDEX],
      [ROUTES.SKYBRAIN_SETTINGS, WORKFORCE_NAV_IDS.SKYBRAIN_SETTINGS],
    ];
    const hit = brain.find(([route]) => pathname.startsWith(route));
    return hit ? hit[1] : WORKFORCE_NAV_IDS.SKYBRAIN_MEMORY;
  }

  let bestMatch: { navId: string; patternLength: number } | null = null;
  for (const [navId, pattern] of Object.entries(WORKFORCE_NAV_TO_ROUTE)) {
    const isMatch =
      pathname === pattern ||
      pathname.startsWith(pattern + "/") ||
      pathname.startsWith(pattern + "?");
    if (isMatch && (!bestMatch || pattern.length > bestMatch.patternLength)) {
      bestMatch = { navId, patternLength: pattern.length };
    }
  }
  return bestMatch?.navId ?? WORKFORCE_NAV_IDS.PEOPLE;
}
